var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.frameStore.baseUrl !== undefined)?_c('v-hips-png-layer',{attrs:{"fade":false,"baseUrl":_vm.frameStore.baseUrl,"animationLod":_vm.Store.config.hipsLayer.animationLod,"lodBias":_vm.Store.config.hipsLayer.lodBias}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }